import React, { useState, useEffect } from 'react'
import { Formik, Form as FormikForm } from 'formik'
import {
	Row,
	Col,
	FormControl,
	Button,
	Modal,
	Form,
	Alert,
	Image,
	// OverlayTrigger,
	// Tooltip,
	Badge,
	ButtonGroup
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faChevronRight,
	faChevronLeft,
	faUserPlus,
	faPencilAlt,
	faMinus,
	faTimes,
	faTrash
} from '@fortawesome/free-solid-svg-icons'
import styles from './ManageUsers.module.scss'
import 'react-day-picker/lib/style.css'
import ReactPaginate from 'react-paginate'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

interface DataProps {
	id: number
	name: string
}
interface VcfKioskType {
	id: number
	label: string
	type: string
}
const ManageUsers = () => {
	const [inputs, setInputs] = useState({
		name: '',
		contact: '',
		email: ''
	})
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [isLoading, setIsLoading] = useState(false)
	const [keyword] = useState('')
	const [users, setUsers] = useState<any[]>([])

	//create user
	const [showCreateUser, setShowCreateUser] = useState(false)
	const [currentStep, setCurrentStep] = useState(1)
	const [services, setServices] = useState({
		MICROSITE: [],
		VCF: [],
		KIOSK: []
	})

	//selected services
	const [selectedMicrosite, setSelectedMicrosite] = useState<string[]>([])
	const [selectedVCF, setSelectedVCF] = useState<string[]>([])
	const [selectedKIOSK, setSelectedKIOSK] = useState<string[]>([])

	//success / error messsages
	const [emptySelect, setEmptySelect] = useState(false)
	const [userCreated, setUserCreated] = useState(false)
	const [userCreationErr, setUserCreationErr] = useState(false)

	//delete user
	const [showDeleteUser, setShowDeleteUser] = useState(false)
	const [deleted, setDeleted] = useState(false)
	const [deleteError, setDeleteError] = useState(false)
	const [deleteId, setDeleteId] = useState(0)

	// pagination
	const [page, setPage] = useState('')
	const [pageSize] = useState(10)
	const [forcePage, setForcePage] = useState(0)
	const [pageCount, setPageCount] = useState(0)
	const [pageBox, setPageBox] = useState('')

	//validation
	const validationSchema = Yup.object().shape({
		name: Yup.string().min(2, t('Too_short')).max(50, t('Too_Long')).required(t('required.field')),
		contact: Yup.number().min(8, t('At_least_8_number')).typeError(t('This_must_be_a_number')),
		email: Yup.string().email().required(t('required.field'))
	})

	// event handlers
	const handleClick = (e: React.ChangeEvent<HTMLInputElement>, type: string): void => {
		const name = e.target.name
		if (type === 'microsite') {
			const tempArr = Array.from(selectedMicrosite)
			//checkbox on or off
			if (tempArr.includes(name)) {
				const unCheck = tempArr.filter(ele => ele !== name)
				setSelectedMicrosite(unCheck)
			} else {
				setSelectedMicrosite(arr => [...arr, name])
			}
		}

		if (type === 'VCF') {
			const tempArr = Array.from(selectedVCF)
			if (tempArr.includes(name)) {
				const unCheck = tempArr.filter(ele => ele !== name)
				setSelectedVCF(unCheck)
			} else {
				setSelectedVCF(arr => [...arr, name])
			}
		}

		if (type === 'KIOSK') {
			const tempArr = Array.from(selectedKIOSK)
			if (tempArr.includes(name)) {
				const unCheck = tempArr.filter(ele => ele !== name)
				setSelectedKIOSK(unCheck)
			} else {
				setSelectedKIOSK(arr => [...arr, name])
			}
		}
		setEmptySelect(false)

	}
	const handleSubmit = async () => {
		//format to MICROSITE_SOUTHEAST,MICROSITE_NTUC,VCF_1,VCF_2,KIOSK_1
		const formatMicrosite = selectedMicrosite.map((ele) => { return 'MICROSITE_' + ele })
		const formatVCF = selectedVCF.map((ele) => { return 'VCF_' + ele })
		const formatKIOSK = selectedKIOSK.map((ele) => { return 'KIOSK_' + ele })
		const combinedServices = formatMicrosite.concat(formatVCF).concat(formatKIOSK)

		if (!combinedServices.length) {
			setEmptySelect(true)
			return
		}
		const data = {
			name: inputs.name,
			email: inputs.email,
			contact: inputs.contact,
			services: combinedServices.toString()
		}

		try {
			await axios.post(process.env.REACT_APP_ROUTE_CRUD_PROFILE as string, data)
			setUserCreated(true)
			setUserCreationErr(false)
		} catch (err) {
			setUserCreated(false)
			setUserCreationErr(true)
		}

	}
	const numbersOnly = (val: string) => {
		const numsCheck = new RegExp('^[0-9]{1,6}$')//6 digits only
		if (val === '') setForcePage(1)

		if (parseInt(val) > pageCount) {
			//minus 1 because react-paginate
			setForcePage(pageCount - 1)
		}
		else if (numsCheck.test(val)) {
			const temp = parseInt(val) - 1
			setForcePage(temp)
		}
	}
	const submitPageNumber = () => {
		numbersOnly(pageBox) //force page number to what user typed
		if (parseInt(pageBox) > pageCount) {
			setPage(pageCount.toString())
		}
		else setPage(pageBox.toString())
	}

	const deleteUser = async () => {
		if (deleteId === 0) return
		try {
			const res = await axios.delete(process.env.REACT_APP_ROUTE_CRUD_PROFILE as string + '/' + deleteId.toString())
			if (res) { setDeleted(true) }
			else setDeleted(false); setDeleteError(false)
		} catch (err) {
			setDeleteError(true)
			console.log(err)
		}
	}

	//on page load/change
	useEffect(() => {
		const getCompanies = async () => {
			setIsLoading(true)
			try {
				const res = await axios.get(process.env.REACT_APP_ROUTE_CRUD_PROFILE as string + `?page=${page}&pageSize=${pageSize}`)
				const services = await axios.get(process.env.REACT_APP_ROUTE_GET_ALL_SERVICES as string)
				setUsers(res.data.users)
				setPageCount(Math.ceil(res.data.usersAggregate / pageSize))
				setIsLoading(false)
				setServices({
					MICROSITE: services.data.MICROSITE.map((ele: string) => {
						return { name: ele, label: ele, type: 'MICROSITE' }
					}),
					VCF: services.data.VCF.map((ele: DataProps) => {
						return { id: ele.id, label: ele.name, type: 'VCF' }
					}),
					KIOSK: services.data.KIOSK.map((ele: DataProps) => {
						return { id: ele.id, label: ele.name, type: 'KIOSK' }
					})
				})
			} catch (err) {
				setIsLoading(false)
				return console.log(err)
			}
		}
		getCompanies()
	}, [page, keyword])

	return (
		<div>
			<Row className='mb-3'>
				<Col className='d-flex justify-content-end'>
					<Button className={styles.createBtn} onClick={() => {
						setShowCreateUser(true)
						setCurrentStep(1)
						setInputs({ name: '', contact: '', email: '' })
					}} >
						<FontAwesomeIcon icon={faUserPlus} />
						<span style={{ paddingLeft: '0.5rem' }}>Create User</span>
					</Button>
				</Col>
			</Row>
			{/* table */}
			{/* header */}
			<div className={styles.tableHeader}>
				<Row className={styles.mobileViewSlideTable}>

					<Col md={8} xs="auto">
						<h6>Name</h6>
					</Col>
					<Col md={2} xs="auto" className='d-flex align-items-center'>
						<h6>Active / Inactive</h6>
					</Col>
					<Col md={1} xs="auto" />

				</Row>

			</div>

			{/* Users */}
			<div>
				{isLoading ? (
					<div className='text-center mt-3'>
						<p>Loading</p>
					</div>
				) : (users && users.map((user, index) => {
					return (
						<div key={index} className={styles.tableBody}>
							<Row>
								<Col md={8} xs={12}>
									<p style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
										<strong>{user?.name}</strong> <br />
										{user?.email}
									</p>
								</Col>

								<Col md={2} xs={6} className='d-flex align-items-center text-center'>
									{/* <OverlayTrigger
										key={user.name}
										placement='right'
										delay={{ show: 250, hide: 400 }}
										overlay={
											<Tooltip id='tooltip-right'>
												Click the edit button to change status
											</Tooltip>
										}
									>
										<div>
											<Form.Check
												type='switch'
												id="custom-switch"
												className={styles.form__switch}
												checked={user?.isActive}
												disabled
											/>
										</div>
									</OverlayTrigger> */}
									&nbsp;&nbsp;&nbsp;
									<Badge bg={user?.isActive ? 'success' : 'warning'}>{user?.isActive ? 'Active' : 'Inactive'}</Badge>
								</Col>
								<Col md={2} xs={6} className='d-flex align-items-center'>
									&nbsp;&nbsp;&nbsp;
									<ButtonGroup>
										<Button
											// className={styles.filterBtn}
											variant='success'
											onClick={() => navigate(`/update-user/${user.id}`)}
										>
											<FontAwesomeIcon icon={faPencilAlt} />
											{/* <span className='ps-2'>Edit</span> */}
										</Button> &nbsp;&nbsp;
										<Button
											// className={styles.deleteUser}
											variant='danger'
											onClick={() => {
												setDeleteId(user.id)
												setShowDeleteUser(true)
											}}
										>
											<FontAwesomeIcon icon={faTrash} />
										</Button>
									</ButtonGroup>
								</Col>
							</Row>
						</div>
					)
				})
				)}
			</div>
			<small className='fst-italic'>Note: An admin who is set to inactive will not be able to log in and access the features</small>

			<Row style={{ marginTop: '20px' }}>
				<Col />
				<Col>
					<ReactPaginate
						containerClassName={styles.pagination}
						previousClassName="page-item"
						nextLinkClassName="page-link"
						// activeClassName="active"
						activeLinkClassName={styles.paginationActive}
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						breakLinkClassName="page-link"
						breakClassName="page-item"
						previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
						pageCount={pageCount}
						onPageChange={e => setPage((e.selected + 1) as unknown as string)}
						nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
						pageRangeDisplayed={3}
						marginPagesDisplayed={3}
						breakLabel="..."
						forcePage={forcePage}
					/>
				</Col>
				<Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<span style={{ fontSize: '14px', color: '#5B7493', paddingTop: '5px' }}>Go to page</span>
					<FormControl
						//type='number'
						style={{ width: '15%', display: 'inline-block', margin: '0 10px', height: '35px' }}
						onChange={e => {
							setPageBox(e.target.value)
						}}
						value={pageBox}
					/>
					<Button onClick={submitPageNumber} variant='primary' className={styles.pageBtn}>
						Go
					</Button>
				</Col>
			</Row>
			{/* Create user modal */}
			<Modal
				show={showCreateUser}
				className={styles.applicantDetailsModal}
				size='lg'
				onHide={() => { setShowCreateUser(false); setUserCreationErr(false) }}
			>
				<Modal.Header closeButton className='border-0' />
				<Modal.Body className='px-5 pb-5 pt-0' style={{ maxHeight: '90vh', overflow: 'auto' }}>
					<Row className='mb-4'>
						<Col>
							<span
								className={`badge ${styles.customBadge}`}
								style={{ backgroundColor: currentStep === 1 ? '#FFF2F2' : '#EDF3FA', border: currentStep === 1 ? '1px solid #FE6565' : '1px solid #5B7493', color: currentStep === 1 ? '#FE6565' : '#5B7493' }}
								onClick={() => setCurrentStep(1)}
							>
								Admin details
							</span>
							<FontAwesomeIcon icon={faMinus} className='mx-3' />
							<span
								className={`badge ${styles.customBadge}`}
								style={{ backgroundColor: currentStep === 2 ? '#FFF2F2' : '#EDF3FA', border: currentStep === 2 ? '1px solid #FE6565' : '1px solid #5B7493', color: currentStep === 2 ? '#FE6565' : '#5B7493' }}
							>
								Assign Permission
							</span>
						</Col>
					</Row>

					{currentStep === 1 && (
						<>
							<h5 className='mb-4'><strong>Create User</strong></h5>
							<Formik
								enableReinitialize
								initialValues={inputs}
								validationSchema={validationSchema}
								onSubmit={values => {
									setInputs({ name: values.name, contact: values.contact, email: values.email })
									setCurrentStep(2)
								}}
							>
								{({ values, handleChange, errors, touched }) => (
									<FormikForm>
										<Form.Group className='mb-4 mt-5'>
											<Col>
												<Form.Label>Name</Form.Label>
												<span className={styles.mandatory}>*</span>
												<Form.Control
													className={styles.formControl}
													type='text'
													placeholder={t('profile_personal.enter_name')}
													name='name'
													value={values.name}
													onChange={handleChange}
													required
												/>
												{errors.name && touched.name && <div className={styles.errMessage}
												>{errors.name}</div>}
											</Col>
										</Form.Group>

										<Form.Group className='mb-3'>
											<Col>
												<Form.Label>Contact Number</Form.Label>
												<Form.Control
													className={styles.formControl}
													placeholder='Enter your contact number'
													name='contact'
													value={values.contact}
													onChange={handleChange}
													minLength={8} maxLength={8}
												/>
												{errors.contact && touched.contact && <div className={styles.errMessage}
												>{errors.contact}</div>}
											</Col>
										</Form.Group>

										<Form.Group className='mb-3'>
											<Col>
												<Form.Label>{t('profile.email')}</Form.Label>
												<span className={styles.mandatory}>*</span>
												<Form.Control
													className={styles.formControl}
													type='email'
													placeholder={t('sign_up.email_plhlder')}
													name='email'
													value={values.email}
													onChange={handleChange}
													required
												/>
												{errors.email && touched.email && <div className={styles.errMessage}
												>{errors.email}</div>}
											</Col>
										</Form.Group>

										<Row className='text-end'>
											<Col>
												<Button className={styles.createBtn} type='submit'>
													<span className='px-5'>Next</span>
												</Button>
											</Col>
										</Row>
									</FormikForm>
								)}
							</Formik>



						</>
					)}

					{currentStep === 2 && (
						<>
							<h5 className='mb-4'><strong>Assign Permission</strong></h5>
							<Row className='mb-3'>
								<Col>
									<Form.Group>
										<Form.Label>Choose which services the user is able to access</Form.Label>
										<span className={styles.mandatory}>*</span>
									</Form.Group>

									<div className='mt-1 mb-1'>
										<Image src='/img/briefcase.png' alt='se' width='20' height='17' />
										<span style={{ fontWeight: '500', paddingLeft: '18px', color: 'black' }}>Microsites</span>
									</div>
									<Form.Check className="mb-1">
										<Form.Check.Input
											style={{ border: '1px solid #DEE7F2' }}
											type="checkbox"
											name="NTUC"
											id="NTUC"
											onChange={(e) => handleClick(e, 'microsite')}
											checked={selectedMicrosite.includes('NTUC')}
										/>
										<Form.Check.Label htmlFor='NTUC' style={{ paddingLeft: '13px' }}>LMUnited</Form.Check.Label>
									</Form.Check>
									<Form.Check className="mb-1">
										<Form.Check.Input
											style={{ border: '1px solid #DEE7F2' }}
											type="checkbox"
											name="SOUTHEAST"
											id="SOUTHEAST"
											onChange={(e) => handleClick(e, 'microsite')}
											checked={selectedMicrosite.includes('SOUTHEAST')}
										/>
										<Form.Check.Label htmlFor="SOUTHEAST" style={{ paddingLeft: '13px' }}>Jobs @ SouthEast</Form.Check.Label>
									</Form.Check>
									<div className='mt-3 mb-1'>
										<Image src='/img/VCFIcon.png' alt='VCFIcon' width='20' height='17' />
										<span style={{ fontWeight: '500', paddingLeft: '18px', color: 'black' }}>Virtual Career Fairs</span>
									</div>
									{services.VCF.map((ele: VcfKioskType) => {
										return (
											<Form.Check className="mb-1" key={ele.id}>
												<Form.Check.Input
													style={{ border: '1px solid #DEE7F2' }}
													type="checkbox"
													name={(ele.id).toString()}
													id={ele.label}
													onChange={(e) => handleClick(e, 'VCF')}
													checked={selectedVCF.includes((ele.id).toString())}
												/>
												<Form.Check.Label htmlFor={ele.label} style={{ paddingLeft: '13px' }}>{ele.label}</Form.Check.Label>
											</Form.Check>
										)
									})}
									<div className='mt-3 mb-1'>
										<Image src='/img/kiosks.png' alt='jobstations' width='15' height='23' />
										<span style={{ fontWeight: '500', paddingLeft: '18px', color: 'black' }}>Job Stations</span>
									</div>
									{services.KIOSK.map((ele: VcfKioskType) => {
										return (
											<Form.Check className="mb-1" key={ele.id}>
												<Form.Check.Input
													style={{ border: '1px solid #DEE7F2' }}
													type="checkbox"
													name={(ele.id).toString()}
													id={ele.label}
													onChange={(e) => handleClick(e, 'KIOSK')}
													checked={selectedKIOSK.includes((ele.id).toString())}
												/>
												<Form.Check.Label htmlFor={ele.label} style={{ paddingLeft: '13px' }}>{ele.label}</Form.Check.Label>
											</Form.Check>
										)
									})}

								</Col>
							</Row>


							{emptySelect && <Alert variant='danger'>Services must not be empty</Alert>}
							{userCreationErr && <Alert variant='danger'>Something went wrong, please try again later</Alert>}
							{userCreated &&
								<Alert variant='success'>Success! An email has also been sent to the admin&apos;s account to set his/her password.
									<p>Click <a className={styles.form__link} onClick={() => window.location.reload()}>here</a> to refresh page</p>
								</Alert>
							}
							<Row className='justify-content-between'>
								<Col>
									<Button className={styles.backBtn} type='button' onClick={() => setCurrentStep(1)}>
										<span className='px-5'>Back</span>
									</Button>
								</Col>
								<Col className='text-end'>
									<Button className={styles.createBtn} type='button' onClick={() => handleSubmit()}>
										<span className='px-5'>Create</span>
									</Button>
								</Col>
							</Row>
						</>
					)}

				</Modal.Body>
			</Modal>
			{/* Delete user modal */}
			<Modal centered show={showDeleteUser} onHide={() => setShowDeleteUser(false)} size='lg'>
				<Modal.Body className='text-center'>
					<div style={{ textAlign: 'right' }}>
						<FontAwesomeIcon icon={faTimes} style={{ fontSize: '2.5em' }} onClick={() => setShowDeleteUser(false)} />
					</div>
					<br />
					<Row className='justify-content-center'>
						<Col sm={8}>
							<p><strong>Are you sure you want to delete this user?</strong></p>
							<br />
							<Row>
								<Col>
									{deleteError && <Alert variant='danger'>Something went wrong, please try again later</Alert>}
								</Col>
							</Row>
							{!deleted ?
								(<Row>
									<Col>
										<Button
											variant='primary'
											className={`${styles.block_on_mobile} text-white px-5 mb-3 mb-sm-0`}
											onClick={() => {
												deleteUser()
											}}>
											{t('confirm')}
										</Button>
									</Col>
									<Col>
										<Button
											variant='outline-primary'
											className={`${styles.block_on_mobile} px-5`}
											onClick={() => {
												setShowDeleteUser(false)
											}}
										>Cancel
										</Button>
									</Col>
								</Row>)
								:
								<Row>
									<Col>
										<p>User deleted! Click <a className={styles.form__link} onClick={() => window.location.reload()}>here</a> to refresh page</p>
									</Col>
								</Row>
							}

						</Col>
					</Row>
					<br />
				</Modal.Body>
			</Modal>
		</div >
	)
}

export default ManageUsers